import type { FunctionComponent } from 'react';
import {
  MultiStepForm,
  MultiStepFormRouter,
} from '@kanda-libs/ks-component-ts';

import useContinueApplication from './useContinueApplication';

const ContinueApplication: FunctionComponent = function () {
  const { pages, steps, initialData } = useContinueApplication();
  return (
    <MultiStepForm
      steps={steps}
      initialStepIndex={0}
      initialData={initialData}
      addStepsToUrl={false}
    >
      <MultiStepFormRouter pages={pages} />
    </MultiStepForm>
  );
};

ContinueApplication.displayName = 'ContinueApplication-view';

export default ContinueApplication;
